import api from "./api";

/**
 * Cotação Fase 2 — endpoints PÚBLICOS da página do cliente (/cotacao/:token).
 * Sem auth: autorizados pelo `publicToken` na URL (rate-limited no BE). Mesmo padrão
 * do `publicHotel.js` (usa o cliente `api`; Bearer, se houver, é ignorado pelo BE).
 * Contrato: .context/api-contracts/BACKEND-HANDOFF-cotacao-fase2.md §5.
 */

// GET — retorna a cotação p/ seleção. O BE RE-COTA ao vivo (disponibilidade/preço/câmbio)
// e registra a visualização. Retorno: { status, trechos[], itens[], cambio{usdBrl,data,validoAte},
// selecaoCliente, agencyViewToken, reservas? } (ou embrulhado em { quote }).
export const getPublicQuote = (token) =>
	api.get(`/api/v1/public/quote/${token}`).then((r) => r.data);

// POST approve — { selecao: {[trechoId]: itemId} }. 409 se algum item caiu (FE reabre seleção).
export const approvePublicQuote = (token, selecao) =>
	api.post(`/api/v1/public/quote/${token}/approve`, { selecao }).then((r) => r.data);

// POST reopen-selection — cliente refaz a seleção após aprovar (aprovada → aguardando_selecao).
export const reopenPublicSelection = (token) =>
	api.post(`/api/v1/public/quote/${token}/reopen-selection`).then((r) => r.data);

/**
 * POST voucher — pede o voucher da reserva PAGA. O PDF NÃO é servido por URL: o BE
 * gera sob demanda e manda por e-mail, e o destinatário sai do banco (responsável
 * pelo pagamento, com fallback no contato da cotação) — nunca da requisição. Assim,
 * quem tem o link consegue disparar o envio, mas não consegue receber o documento.
 *
 * Retorno: { success, enviado, email } — `email` vem MASCARADO (r*****o@dominio.com).
 * Erros: NOT_PAID (409), BOOKING_CANCELLED (409), BOOKING_NOT_FOUND (404),
 * NO_RECIPIENT (409), EMAIL_FAILED (502). A rota é rate-limited no BE.
 */
export const requestReservationVoucher = (token, bookingId) =>
	api.post(`/api/v1/public/quote/${token}/reserva/${bookingId}/voucher`).then((r) => r.data);
